import { render, staticRenderFns } from "./ItsOrderOutBoundDetail.vue?vue&type=template&id=01f48ff8&scoped=true&"
import script from "./ItsOrderOutBoundDetail.vue?vue&type=script&lang=js&"
export * from "./ItsOrderOutBoundDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsOrderOutBoundDetail.vue?vue&type=style&index=0&id=01f48ff8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f48ff8",
  null
  
)

export default component.exports